import * as Map from './MapDataList.ts';
import { MapSettingEnum } from '../GameEnums.ts';
import { ArrayUtils } from '@colonist/utils';
export class MapDataController {
    static getMapDataForMap(mapSetting) {
        for (const map of MapDataController.mapDataList){
            if (map.mapEnum == mapSetting) return map.getNewInstanceOfData();
        }
        return undefined;
    }
    static getMapName(mapSetting) {
        var _this_getMapDataForMap;
        const mapText = (_this_getMapDataForMap = this.getMapDataForMap(mapSetting)) === null || _this_getMapDataForMap === void 0 ? void 0 : _this_getMapDataForMap.name;
        const defaultMapText = {
            key: 'strings:colonistCommon.utils.#buffer',
            options: {
                value: MapSettingEnum[mapSetting]
            }
        };
        return mapText !== null && mapText !== void 0 ? mapText : defaultMapText;
    }
    static getMapDataCompatibleWithGameMode(modeSetting) {
        const compatibleMaps = [];
        for (const map of MapDataController.mapDataList){
            if (!ArrayUtils.elementInArray(map.compatibleGameModes, modeSetting)) continue;
            compatibleMaps.push(map);
        }
        return compatibleMaps;
    }
    static getMapDataCompatibleWithGameModes(modeSettings) {
        const compatibleMaps = [];
        for (const map of MapDataController.mapDataList){
            for (const compatibleModes of map.compatibleGameModes){
                if (!ArrayUtils.elementInArray(modeSettings, compatibleModes)) continue;
                compatibleMaps.push(map);
                break;
            }
        }
        return compatibleMaps;
    }
    static isMapActive(mapSetting) {
        for (const map of MapDataController.mapDataList){
            if (map.mapEnum != mapSetting) continue;
            return map.isActive;
        }
        return false;
    }
}
MapDataController.mapDataList = [
    new Map.MapDataClassic4P(),
    new Map.MapDataTutorialClassic4P(),
    new Map.MapDataCampaignLevel1(),
    new Map.MapDataCampaignLevel2(),
    new Map.MapDataClassic4PRandom(),
    new Map.MapDataClassic56P(),
    new Map.MapDataClassic78P(),
    new Map.MapDataSS1HeadingForNewShores3P(),
    new Map.MapDataSS2FourIslands3P(),
    new Map.MapDataSS3FogIslands3P(),
    new Map.MapDataSS4ThroughTheDesert3P(),
    new Map.MapDataSS1HeadingForNewShores4P(),
    new Map.MapDataSS2FourIslands4P(),
    new Map.MapDataSS3FogIslands4P(),
    new Map.MapDataSS4ThroughTheDesert4P(),
    new Map.MapDataTutorialSS1HeadingForNewShores4P(),
    new Map.MapDataTutorialSS2FourIslands4P(),
    new Map.MapDataTutorialSS3FogIslands4P(),
    new Map.MapDataTutorialSS4ThroughTheDesert4P(),
    new Map.MapDataSS1HeadingForNewShores56P(),
    new Map.MapDataSS2SixIslands56P(),
    new Map.MapDataSS3FogIslands56P(),
    new Map.MapDataSS4ThroughTheDesert56P(),
    new Map.MapDataEarth(),
    new Map.MapDataEarthSeafarers(),
    new Map.MapDataUSA(),
    new Map.MapDataUK(),
    new Map.MapDataUKSeafarers(),
    new Map.MapDataDiamond(),
    new Map.MapDataGear(),
    new Map.MapDataLakes(),
    new Map.MapDataPond(),
    new Map.MapDataTwirl(),
    new Map.MapDataShuffleBoard(),
    new Map.MapDataBlackForest(),
    new Map.MapDataVolcano(),
    new Map.MapDataCircle(),
    new Map.MapDataKite(),
    new Map.MapDataDuel(),
    new Map.MapDataMiniBase(),
    new Map.MapDataKingOfTheHill(),
    new Map.MapDataMountainOfRiches(),
    new Map.MapDataDoggo(),
    new Map.MapDataTradeIslands(),
    new Map.MapDataTradeIslandSeafarers(),
    new Map.MapDataVietnam(),
    new Map.MapDataTurningTidesClassic(),
    new Map.MapDataTurningTidesSeafarers(),
    new Map.MapDataTwoIsles(),
    new Map.MapDataJellyFish(),
    new Map.MapDataRomania(),
    new Map.MapDataMonopoly(),
    new Map.MapDataGoldRush(),
    new Map.MapDataIstanbul(),
    new Map.MapDataIstanbulSeafareres(),
    new Map.MapDataEurope(),
    new Map.MapDataEuropeSeafarers(),
    new Map.MapDataStripes(),
    new Map.MapDataMonopolyIslands(),
    new Map.MapDataMonopolyIslandsSeafarers()
];
